import { createSlice } from "@reduxjs/toolkit"

export const customerVouchersApplySlice = createSlice({
	name: "customerVouchersApply",
	initialState: {
		customerVouchersApply: "",
		errors: [],
	},

	reducers: {
        getCustomerVouchersApply: (state, action) => {
            // console.log(action.payload);
			state.customerVouchersApply = action.payload
		},
		getCustomerVouchersApplyList: (state, action) => {
            
			state.customerVouchersApply = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getCustomerVouchersApply, getCustomerVouchersApplyList, getErrors} = customerVouchersApplySlice.actions

export default customerVouchersApplySlice.reducer
